module.exports = __webpack_public_path__ + "img/right_five.f9f2f4fe.svg";